module.exports = __webpack_public_path__ + "img/home_1.1.e1918db5.webp";